import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get_user, login } from "../api/api";
import { toast } from "react-toastify";
import { useAuth } from "../components/Auth/userContext";
import LoadingScreen from "react-loading-screen";

const Login = () => {
  const { state } = useParams();
  const { user, setUser } = useAuth();
  const [currentpath, setCurrentpath] = useState();
  const [signUpDetails, setSignUpDetails] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [signInDetails, setSignInDetails] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [NewPasswordShow, setNewPasswordShow] = useState(false);
  // const [confirmNewPasswordShow, setConfirmNewPasswordShow] = useState(false);

  const navigate = useNavigate();
  // console.log(state);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpDetails({ ...signUpDetails, [name]: value });
  };

  const handleSignInDetails = (e) => {
    const { name, value } = e.target;
    setSignInDetails({ ...signInDetails, [name]: value });
  };

  useEffect(() => {
    setCurrentpath(state.toLowerCase());
  }, [state]);

  // const handleSignUp = async (e) => {
  //   e.preventDefault();
  //   try {
  //     let result = await signUp(
  //       signUpDetails.username,
  //       signUpDetails.email,
  //       signUpDetails.password
  //     );
  //     if (result.data) {
  //       // console.log(result);
  //       alert("signUp Successfull");
  //       setSignUpDetails({ username: "", email: "", password: "" });
  //       navigate("/login/signIn");
  //     } else {
  //       alert(result.error.detail[0].msg);
  //     }
  //   } catch (e) {
  //     alert(e);
  //   }
  // };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let result = await login(signInDetails.id, signInDetails.password);
      // console.log("I am called");

      if (result.data) {
        // console.log("I am called too" + result.data.message);
        localStorage.setItem("token", result.data.message);
        toast.success("SignIn Successful");
        setLoading(false);
        navigate("/digitalconversion/xml_to_dita");
        let userData = await get_user();
        if (userData.data) {
          setUser(userData.data);
        } else {
          toast.error(result.error.message);
          setLoading(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const token = localStorage.getItem("token"); // or sessionStorage, or context
  //   if (token) {
  //     navigate("/dita/xml_to_dita");
  //   }
  // }, []);

  console.log(user);

  const renderScreen = () => {
    switch (state) {
      case "signin":
        return (
          <form className="flex flex-col w-full gap-2" onSubmit={handleSignIn}>
            <div className="text-24 font-bold mb-10 text-333333">
              <h1>Login to your account</h1>
            </div>
            <label className="text-625C58">Email ID</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px] border-[1px] border-commonborder">
              <input
                className="bg-F1F3F6 w-10/12 ml-4 outline-none"
                type="text"
                placeholder="Enter your user ID"
                value={signInDetails.id}
                name="id"
                onChange={handleSignInDetails}
                required
              ></input>
              <span className="mr-2">
                <img
                  src={process.env.PUBLIC_URL + "/images/login/mail.png"}
                  alt=""
                />
              </span>
            </div>
            <label className="mt-4 text-625C58">Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px] border-[1px] border-commonborder">
              <input
                className="bg-F1F3F6 w-10/12 ml-4 outline-none"
                type={passwordShow ? "text" : "password"}
                placeholder="Your Password"
                value={signInDetails.password}
                name="password"
                onChange={handleSignInDetails}
                required
              ></input>
              <span className="mr-2">
                {!passwordShow ? (
                  <div onClick={() => setPasswordShow(true)}>
                    <img
                      src={process.env.PUBLIC_URL + "/images/eyeclose.png"}
                      alt="hidepassword"
                    />
                  </div>
                ) : (
                  <div onClick={() => setPasswordShow(false)}>
                    <img
                      src={process.env.PUBLIC_URL + "/images/eyeopen.png"}
                      alt="hidepassword"
                    />
                  </div>
                )}
              </span>
            </div>
            {/* <Link
              to={"/forgetPassword"}
              className="text-right font-medium text-333333"
            >
              <p>Forget Password ?</p>
            </Link> */}
            <button
              type="submit"
              className="h-[56px] bg-highlight text-white mt-6 rounded-[12px] font-semibold text-18"
            >
              GET STARTED
            </button>
          </form>
        );

      case "signup":
        return (
          <form className="flex flex-col w-full gap-3" onSubmit={""}>
            <label className="text-666666">Enter Username</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="text"
                name="username"
                value={signUpDetails.username}
                onChange={handleChange}
                placeholder="Enter username"
              ></input>
            </div>
            <label className="text-666666">Enter Email Address</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="email"
                name="email"
                value={signUpDetails.email}
                onChange={handleChange}
                placeholder="Enter your Email address"
              ></input>
            </div>
            <label className="text-666666">Enter Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="password"
                name="password"
                value={signUpDetails.password}
                onChange={handleChange}
                placeholder="Enter password"
              ></input>
            </div>
            {/* <Link className="w-full mt-12" to={"/login/signIn"}> */}
            <button
              type="submit"
              className="h-[56px] w-full bg-F37021 text-white  rounded-[12px] font-semibold"
            >
              Sign Up
            </button>
            {/* </Link> */}
          </form>
        );
      case "forgetpassword":
        return (
          <form className="flex flex-col w-full gap-3">
            <label className="text-666666">Enter Email Address</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="email"
                placeholder="Enter your Email address"
              ></input>
            </div>
            <Link to={"/verifyCode"} className="w-full">
              <button className="h-[56px] btn text-white mt-12 rounded-[12px] font-semibold w-full">
                Get Code
              </button>
            </Link>
          </form>
        );
      case "verifycode":
        return (
          <form className="flex flex-col w-full gap-3">
            <label className="text-666666">Enter Code</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type="number"
                placeholder="Enter your code to verify"
              ></input>
            </div>
            <Link to={"/setPassword"} className="w-full  mt-12">
              <button className="h-[56px] w-full btn text-white rounded-[12px] font-semibold">
                Verify Code
              </button>
            </Link>
          </form>
        );
      case "setpassword":
        return (
          <form className="flex flex-col w-full gap-3">
            <label className="text-666666">Set New Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type={NewPasswordShow ? "text" : "password"}
                placeholder="Enter your Password"
              ></input>
              <span className="mr-2">
                {!NewPasswordShow ? (
                  <button onClick={() => setNewPasswordShow(true)}>
                    <img
                      src={process.env.PUBLIC_URL + "/images/eyeclose.png"}
                      alt="hidepassword"
                    />
                  </button>
                ) : (
                  <button onClick={() => setNewPasswordShow(false)}>
                    <img
                      src={process.env.PUBLIC_URL + "/images/eyeopen.png"}
                      alt="hidepassword"
                    />
                  </button>
                )}
              </span>
            </div>
            <label className="mt-6 text-666666">Confirm New Password</label>
            <div className="h-[56px] w-full bg-F1F3F6 flex items-center rounded-[12px]">
              <input
                className="bg-F1F3F6 w-10/12 ml-4"
                type={confirmPasswordShow ? "text" : "password"}
                placeholder="Confirm your Password"
              ></input>
              <span className="mr-2">
                {!confirmPasswordShow ? (
                  <button onClick={() => setConfirmPasswordShow(false)}>
                    <img
                      src={process.env.PUBLIC_URL + "/images/eyeclose.png"}
                      alt="hidepassword"
                    />
                  </button>
                ) : (
                  <button onClick={() => setConfirmPasswordShow(true)}>
                    <img
                      src={process.env.PUBLIC_URL + "/images/eyeopen.png"}
                      alt="hidepassword"
                    />
                  </button>
                )}
              </span>
            </div>
            {/* <Link to={"/signIn"} className="w-full mt-12"> */}
            <button
              type="submit"
              className="h-[56px] btn text-white w-full rounded-[12px] font-semibold mt-12"
            >
              Set Password
            </button>
            {/* </Link> */}
          </form>
        );

      default:
        break;
    }
  };

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing please wait ...."
    >
      <div className="w-full flex justify-center h-[100vh] loginbg">
        <div className="2xl:container w-full h-full flex flex-col gap-8 justify-center items-center overflow-auto">
          <div className="w-1/2 md:w-3/4 flex justify-center flex-col items-center gap-5">
            <img
              src={process.env.PUBLIC_URL + "/images/transforma.svg"}
              alt="transforma_logo"
            />
            <p className="text-20 font-bold">Digital Conversion Platform</p>
          </div>
          <div className="flex flex-col w-10/12 lg:w-3/12 text-left p-10 border-[1px] rounded-[24px] border-[#D1D0CF] bg-gradient-to-b from-[#DBE9FF] to-30% to-[#FFFFFF]">
            {renderScreen()}
          </div>
        </div>
      </div>
    </LoadingScreen>
  );
};

export default Login;
